import styled from 'styled-components';
import { motion } from 'framer-motion';

interface WrapperProps {
  position: 'sticky' | 'fixed';
}

export const Wrapper = styled(motion.div)<WrapperProps>(({ theme, position }) => ({
  boxShadow: theme.shadows[500],
  borderRadius: 32,
  padding: 8,
  background: theme.colors.bg,
  display: 'inline-flex',
  alignItems: 'center',
  gap: 16,
  boxSizing: 'border-box',
  bottom: 0,
  maxWidth: '100%',
  position,
  left: position === 'fixed' ? '50%' : 'unset',
}));
